import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";

const flashcards = [
  { word: "Hola", pronunciation: "oh-lah", translation: "Hello", color: "#FFEB3B" },
  { word: "Adiós", pronunciation: "ah-dee-ohs", translation: "Goodbye", color: "#FF5722" },
  { word: "Gracias", pronunciation: "grah-see-ahs", translation: "Thank you", color: "#8BC34A" },
  { word: "Lo siento", pronunciation: "loh syehn-toh", translation: "Sorry", color: "#03A9F4" },
];

const Level1_1_Spanish = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const reciteText = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "es-ES";
    window.speechSynthesis.speak(utterance);
  };

  const stopRecitingText = () => {
    window.speechSynthesis.cancel();
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <motion.h2
            className="mb-4"
            style={{ color: "#4A90E2" }}
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Lesson 1: Introduction to Spanish
          </motion.h2>
          <motion.p
            className="lead"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2 }}
          >
            Welcome to your first Spanish lesson! In this lesson, you'll learn some basic greetings
            and essential vocabulary.
          </motion.p>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col lg={12} className="text-center">
          <motion.h3
            className="mb-4"
            style={{ color: "#FF9800" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
          >
            Vocabulary
          </motion.h3>
        </Col>
      </Row>

      <Row className="justify-content-center">
        {flashcards.map((card, index) => (
          <Col lg={3} md={4} sm={6} xs={12} key={index} className="mb-4">
            <motion.div
              whileHover={{ scale: 1.1, rotate: 3 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: /* index * */ 0.2 }}
              onMouseEnter={() => reciteText(card.translation)}
              onMouseLeave={() => stopRecitingText()}
            >
              <Card
                className="h-100"
                style={{
                  backgroundColor: card.color,
                  borderRadius: "15px",
                  transition: "transform 0.3s",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                  <h4
                    style={{
                      fontSize: "2rem",
                      color: "#fff",
                      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.4)",
                    }}
                  >
                    {card.word}
                  </h4>
                  <motion.p
                    style={{
                      fontSize: "1.2rem",
                      color: "#fff",
                      margin: "10px 0",
                    }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                  >
                    {card.pronunciation}
                  </motion.p>
                  <motion.p
                    style={{ fontSize: "1rem", color: "#fff" }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                  >
                    {card.translation}
                  </motion.p>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>

      <Row className="justify-content-end">
        <Col md={4} className="d-flex justify-content-end">
          <Button variant="secondary" className="mb-3 mt-5" onClick={goBack}>
            Go back
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Level1_1_Spanish;
